import React from 'react';
import {Route, Switch} from 'react-router-dom';

import Home from '../pages/home';
import Consent from '../pages/consent';
import ConsentError from '../pages/consent-error';
import Main from '../pages/main';
import Personal from '../pages/personal';
import Privatisation from '../pages/privatisation';
import {ConfigProvider} from 'antd';
import {connect} from 'react-redux';
import zh from 'antd/lib/locale/zh_CN';
import us from 'antd/lib/locale/en_US';
import Login from '../pages/login';

const Routers = (props) => (
    <ConfigProvider locale={ props.locale.includes('zh') ? zh : us }>
        <Switch>
            <Route path="/" exact component={ Home }/>
            <Route path="/login" component={ Login }/>
            <Route path="/consent" component={ Consent }/>
            <Route path="/consent-error" component={ ConsentError }/>
            <Route path={["/private/device-binding", "/private/access-configuration", "/private/device-binding-new"]} component={ Privatisation }/>
            <Route path={["/main", "/cloud-to-cloud", "/introductions", "/private"]} component={ Main }/>
            <Route path="/personal" component={ Personal }/>
            
        </Switch>
    </ConfigProvider>
);


const mapState2Props = state => ({
    locale: state.language.language,
});
export default connect(mapState2Props, null)(Routers);
